import { useTranslation } from 'libs/i18n'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'

export const useLoginValidationSchema = () => {
	const { t } = useTranslation()
	const minPasswordLength = 7

	const loginValidationSchema = yup.object({
		email: yup.string().email(t('Must be valid email')).required(t('Email is required')),
		password: yup
			.string()
			.required(t('Password is required'))
			.min(
				minPasswordLength,
				t('Password is too short - should be {{ count }} chars minimum.', {
					count: minPasswordLength
				})
			)
	})

	return yupResolver(loginValidationSchema)
}
